import { DateRange } from 'react-day-picker'

import { IForm } from 'core-components/classes/models/IForm'
import { ICheckedValue } from 'core-components/library/list/types'
import { BaseCrud, IDataProviderFilter, IFilter } from 'core-components/types'

export type TFilterValue = string | string[] | DateRange | IDataProviderFilter | IFilter | null

export interface IFilterPanels {
  [key: string]: IForm[]
}

interface ISources {
  [key: string]: {
    source: BaseCrud
    caption: string
  }
}

export interface IAccordions {
  [key: string]: boolean
}

export interface IFilterValues {
  [key: string]: TFilterValue
}

export interface IFilterCheckedValues {
  [key: string]: ICheckedValue[]
}

export enum TClearButtonPosition {
  Main = 'Main',
  FilterRow = 'FilterRow',
  /**
   * Main and FilterRow visibility
   */
  Full = 'Full',
}

export interface IAccordionFilterProps {
  /**
   * Filters Source
   */
  source: BaseCrud
  /**
   * Sources for filters like 'multiselect' and 'dropdown'
   */
  editorSources?: ISources
  /**
   * Callback function fires when filter is changed
   */
  onChange: (value: IDataProviderFilter) => void
  /**
   * Position for clear button
   */
  clearButtonVisible: TClearButtonPosition
  /**
   * Name of fields which use for working with filters
   */
  dataFields: {
    tabTitle: string
    filterLabel: string
    filterField: string
    source: string
    type: string
    customFilter?: string
    defaultValue?: string
    hierarchyField?: string
  }
  /**
   * A Class name for component root node
   */
  className?: string
  /**
   * Array of expanded groups by default
   */
  expandedGroups?: string[]
  /**
   * An option for collapse other groups on open new group
   */
  collapseGroupOnChange?: boolean
  /**
   * Filters set
   */
  value?: IFilterValues
}

export interface IDataFilterValues<FilterType = TFilterValue> {
  field: string
  filter: FilterType
  onFilterChange: (filter: IDataProviderFilter | IFilter | null) => void
  dataFilterValues: Record<keyof IAccordionFilterProps['dataFields'], unknown>
}
